{
  "출제":"출제",
  "출제자":"출제자",
  "강의":"강의",
  "개념강의":"개념강의",
  "학원그룹교재":"학원그룹교재",
  "학원 공유 교재": "내 교재",
  "학원그룹 공유 교재": "학원그룹 교재",
  "학원 공유 학습지": "내 학습지",
  "학원그룹 공유 학습지": "학원그룹 학습지",
  "학원": "학원",
  "반응형평가": "반응형평가",
  "관리자 권한": "관리자",
  "전체 학생 권한": "전체 학생",
  "담당 학생 권한": "담당 학생",
  "그룹 선택": "그룹 선택"
}